import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { SideMenuBarComponent } from '../side-menu-bar/side-menu-bar.component';
@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [HeaderComponent, SideMenuBarComponent, RouterModule, CommonModule],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent {
  isOpenSideBar:boolean = false;
  sideBarOnHeader!: ElementRef;
  @ViewChild('sideNav') sideNavElement!: ElementRef;

  receiveHeaderElement(element: ElementRef) {
    this.sideBarOnHeader = element;
  }
  onOpenSideBar(event:any){
    this.isOpenSideBar = !this.isOpenSideBar;
  }
  closeSideBar(){
    this.isOpenSideBar = false;
  }

  @HostListener('document:click',['$event'])onClickOutSide(event: Event) {
    if(!(this.sideNavElement.nativeElement.contains(event.target) || this.sideBarOnHeader.nativeElement.contains(event.target))  && this.isOpenSideBar) {
      this.isOpenSideBar = false;
    } 
  }
 
}
